import { render, staticRenderFns } from "./attachments-type.vue?vue&type=template&id=6338d618"
import script from "./attachments-type.vue?vue&type=script&lang=js"
export * from "./attachments-type.vue?vue&type=script&lang=js"
import style0 from "./attachments-type.vue?vue&type=style&index=0&id=6338d618&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports